export default __webpack_public_path__ + "static/planning-development-accomplishment-1-1201c286204cdbae4a3dc09694a48235.webp";